import { supabase } from "../supabaseClient";

const parseInvokePayload = async (data, error) => {
  if (data && typeof data === "object") return data;
  if (!error?.context?.json) return null;
  try {
    return await error.context.json();
  } catch (_) {
    return null;
  }
};

const invokeCardPayments = async (organizationId, action) => {
  const { data, error } = await supabase.functions.invoke(
    "organization-card-payments",
    {
      body: { organizationId, action },
    }
  );
  const payload = await parseInvokePayload(data, error);
  if (payload?.status === "not_configured") {
    return payload;
  }
  if (error) {
    throw new Error(
      payload?.error || error.message || "Could not load card payments."
    );
  }
  if (payload?.error) {
    throw new Error(payload.error);
  }
  return payload;
};

export const getCardPaymentsStatus = (organizationId) =>
  invokeCardPayments(organizationId, "status");

export const startCardPaymentsSession = (organizationId) =>
  invokeCardPayments(organizationId, "start");

export const refreshCardPaymentsSession = (organizationId) =>
  invokeCardPayments(organizationId, "session");

export const getCardPaymentsDashboard = (organizationId) =>
  invokeCardPayments(organizationId, "dashboard");

export const hasStripePublishableKey = () =>
  Boolean(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const cardPaymentsStatusLabel = (status) => {
  if (status === "ready") return "Card payments are on";
  if (status === "needs_information") return "Stripe needs more information";
  if (status === "not_configured") return "Card payments is not configured";
  return "Not started";
};

export const formatCardPaymentsHint = (code) => {
  if (code === "requirements_past_due") {
    return "Stripe still needs information from an earlier step.";
  }
  if (code === "requirements_pending_verification") {
    return "Stripe is checking the information you submitted.";
  }
  if (code === "under_review") {
    return "Stripe is reviewing this account.";
  }
  return String(code).replace(/_/g, " ");
};
